export enum TemporalQueryType {
  DATE = 'd',
  MONTH = 'm',
  YEAR = 'y',
  CUSTOM = 'c',
  PERIOD = 'p'
}
